import React, { useCallback } from 'react'
import cn from 'classnames'
import {
  button,
  heading,
  paragraph,
  text,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { styles } from '../styles'

const ChannelOption = ({
  title,
  children,
  className,
  type,
  onSelect,
  icon,
  provider,
  recommended,
}) => {
  const handleClick = useCallback(
    () => {
      onSelect(type, { provider })
    },
    [onSelect, type, provider]
  )
  return (
    <button
      type="button"
      css={[button.styles.preflight, text.styles.textSm, styles.optionCard]}
      className={cn(
        'grui pt-7 pb-9 px-8 flex flex-col items-center relative',
        className
      )}
      onClick={handleClick}
      data-test-id={`button-list-item-${type}`}
    >
      {icon}
      <h5 css={[heading.styles.h5, text.styles.fontSemibold]}>{title}</h5>
      <div css={text.styles.textSm} className="grui flex-1">
        {children}
      </div>
      {recommended && (
        <span
          className="grui py-2 px-4"
          css={[
            paragraph.styles.preflight,
            text.styles.text3Xs,
            text.styles.fontMedium,
            styles.recommended,
          ]}
        >
          Recommended
        </span>
      )}
    </button>
  )
}

export default ChannelOption
